// AP-076 F3.1 · Heartbeat automático do Portal do Cliente (60s).
// Envia para POST /api/portal/monitoring/heartbeat usando o portalApi
// (autenticado pelo portal token). Zero impacto na auth existente.
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { portalApi } from "../context/PortalAuthContext";

const HEARTBEAT_MS = 60000;

export function usePortalHeartbeat(clientId) {
  const location = useLocation();
  const timerRef = useRef(null);
  const pathRef = useRef(location.pathname);
  useEffect(() => { pathRef.current = location.pathname; }, [location.pathname]);

  useEffect(() => {
    if (!clientId) return;
    const ping = async (action = "page_view") => {
      try { await portalApi.post("/portal/monitoring/heartbeat", { path: pathRef.current, action }); } catch {}
    };
    ping(); // imediato ao montar / trocar rota
    timerRef.current = setInterval(() => ping(), HEARTBEAT_MS);
    return () => { if (timerRef.current) clearInterval(timerRef.current); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientId, location.pathname]);
}
